export const getApiUrl = () => {
    const overridePort = undefined;
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;
    const port = overridePort ? overridePort : window.location.port;
    return `${protocol}//${hostname}:${port}`;
}

export const getApiContext = () => {
    return process.env.PUBLIC_URL;
}
